import { FC } from "react";
import { pluralize } from "@common/helpers/string";
import { CommandsListProps } from "./lib";
import { TaskBulkOptionsCommandsList } from "./TaskBulkOptionsCommandsList";

interface Props extends CommandsListProps {
    role: "preparer" | "reviewer" | "manager";
    optionsKey:
        | "applyTemplateEntityBulkPreparerOptions"
        | "applyTemplateEntityBulkReviewerOptions"
        | "applyTemplateEntityBulkManagerOptions";
}

export const ApplyTemplateEntityBulkMemberCommandsList: FC<Props> = ({
    options = {},
    role,
    optionsKey,
}) => {
    const { selectedApplyTemplateEntityCount = 0 } = options;
    const memberOptions = options[optionsKey] ?? [];

    return (
        <TaskBulkOptionsCommandsList
            heading={`Set ${role} for ${selectedApplyTemplateEntityCount} ${pluralize("entity", selectedApplyTemplateEntityCount)}`}
            options={memberOptions}
        />
    );
};
